// Helper jenis order "Dilayani Oleh" (POS_ORDER_TYPE.SERVED_BY).
// Kontrak BE order_type_details / invoice_type_details:
// { users: [{ id: 12 }, { id: null, name: 'Anak magang' }] } — id null = nama manual.

export const isManualServedBy = (user) =>
  user?.id === null || user?.id === undefined || user?.id === ''

/** Kunci identitas pegawai (id user terdaftar atau nama manual). */
export const servedByKey = (user) =>
  isManualServedBy(user)
    ? `name:${String(user?.name || '')
        .trim()
        .toLowerCase()}`
    : `id:${user.id}`

/** Nama tampil; fallback `#id` bila BE hanya mengembalikan id. */
export const servedByDisplayName = (user) =>
  user?.name || (!isManualServedBy(user) ? `#${user.id}` : '')

/** Normalisasi `users` mentah dari BE / form menjadi [{ id, name }]. */
export const parseServedByUsers = (raw) => {
  if (!Array.isArray(raw)) {
    return []
  }
  return raw
    .map((row) => ({
      id: row?.id ?? null,
      name: String(row?.name ?? row?.user?.name ?? '').trim(),
    }))
    .filter((row) => row.name !== '' || !isManualServedBy(row))
}

/** Bentuk payload BE: user terdaftar cukup `{ id }`, nama manual `{ id: null, name }`. */
export const toServedByPayload = (users) =>
  parseServedByUsers(users).map((user) => {
    if (isManualServedBy(user)) {
      return { id: null, name: user.name }
    }
    const numericId = Number(user.id)
    return { id: Number.isFinite(numericId) ? numericId : user.id }
  })

/** "Budi, Sari +2" — `max` = jumlah nama sebelum diringkas. */
export const formatServedByNames = (users, max = Infinity) => {
  const names = parseServedByUsers(users).map(servedByDisplayName).filter(Boolean)
  if (names.length <= max) {
    return names.join(', ')
  }
  return `${names.slice(0, max).join(', ')} +${names.length - max}`
}

/** Ambil pegawai dari data order/invoice (API) atau form kasir. */
export const getServedByUsersFromData = (data) =>
  parseServedByUsers(
    data?.order_type_data?.users ||
      data?.invoice_type_data?.users ||
      data?.invoice_type_details?.users,
  )
